import { styled } from '@mui/system';

export const HeaderContainer = styled('div', {
	name: 'MuiHeaderContainer',
	overridesResolver: (_, styles) => [styles.root],
})(() => ({}));
